import { render } from "./TheLoaiDiaDiem.vue?vue&type=template&id=129018a3"
import script from "./TheLoaiDiaDiem.vue?vue&type=script&lang=js"
export * from "./TheLoaiDiaDiem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__